import React from 'react'
import './Plans.css'
import { plansData } from '../../data/plansData'
import whitetick from '../../assets/whiteTick.png'
import arrow from '../../assets/rightArrow.png'
const Plans = () => {
  return (
    <div className='plans' id='Plans'>
      <div className='blur blur-plan1'></div>
      <div className='blur blur-plan2'></div>
      <div className='plans-text'>
        <span className='stroke-text'>Ready to start</span>
        <span>Your journey</span>
        <span className='stroke-text'>now with us</span>
      </div>
      <div className='plans-cards'>
        {plansData.map((plan, index) => (
          <div key={index} className='card-plan'>
            <div className='card-header'>
              {plan.icon}
              <h4>{plan.name}</h4>
              <h1>${plan.price}</h1>
            </div>
            <div className='card-body'>
              <ul>
                {plan.features.map((feature, index) => (
                  <div className='features'>
                    <img src={whitetick} alt='tick' />
                    <li key={index}>{feature}</li>
                  </div>
                ))}
              </ul>
              <div className='benefits'>
                <span>see more benefits</span>
                <img src={arrow} alt='tick' />
              </div>

              <button className='join-button'>Join Now</button>
            </div>
          </div>
        ))}
      </div>
     
    </div>
  )
}

export default Plans